import insertDataToForm from "./insertDataToForm";

export default function populateOfferFormInfo() {
  const offerForm = document.querySelector(".offer-form-wrap");
  if (!offerForm) return;

  insertDataToForm();

  function insertOfferBasicsToForm() {
    const offerTitle = document.querySelector(
      ".insert-to-form-offer-title"
    ).innerHTML;
    const offerURL = document.querySelector(
      ".insert-to-form-offer-url"
    ).innerHTML;

    const targetTitle = document.querySelector(".dynamic-offer-title input");
    const targetURL = document.querySelector(".dynamic-offer-url input");

    if (targetTitle) {
      targetTitle.value = offerTitle;
    }

    if (targetURL) {
      targetURL.value = offerURL;
    }
  }

  insertOfferBasicsToForm();

  function updateTotalTravellers() {
    const personValue =
      parseInt(document.querySelector("[data-offerform-person-value]").value) ||
      0;
    const childValue =
      parseInt(document.querySelector("[data-offerform-child-value]").value) ||
      0;
    const totalTravellers = personValue + childValue;
    document.getElementById("travellers").textContent = totalTravellers;
  }

  function offerFormControls() {
    const minusButton = document.querySelector("[data-offerform-person-minus]");
    const plusButton = document.querySelector("[data-offerform-person-plus]");
    const personValueInput = document.querySelector(
      "[data-offerform-person-value]"
    );

    const targetContent = document.querySelector(".adults-info");

    function updateTravellersPeople() {
      targetContent.textContent =
        "täiskasvanuid (" + personValueInput.value + ")";

      updateTotalTravellers();
    }

    minusButton.addEventListener("click", function () {
      let currentValue = parseInt(personValueInput.value);
      if (currentValue > 1) {
        personValueInput.value = currentValue - 1;
      }

      updateTravellersPeople();
      insertDataToForm();
    });

    plusButton.addEventListener("click", function () {
      let currentValue = parseInt(personValueInput.value);
      if (currentValue < 4) {
        personValueInput.value = currentValue + 1;
      }

      updateTravellersPeople();
      insertDataToForm();
    });
  }

  function updatePassangerFlexibility() {
    document
      .querySelector(".offer-flexibility-checkbox input")
      .addEventListener("change", function () {
        var span = document.querySelector("span.dates-flexibility");
        if (this.checked) {
          span.innerHTML = "JAH";
        } else {
          span.innerHTML = "-";
        }

        insertDataToForm();
      });
  }

  updatePassangerFlexibility();

  const controlsPresent = document.querySelector(".offerform-person-selector");

  if (controlsPresent) {
    offerFormControls();
  }

  function offerFormControlsChildren() {
    const minusButton = document.querySelector("[data-offerform-child-minus]");
    const plusButton = document.querySelector("[data-offerform-child-plus]");
    const personValueInput = document.querySelector(
      "[data-offerform-child-value]"
    );
    const targetContent = document.querySelector(".children-info");
    const ageSelectItems = document.querySelectorAll("[data-age-select-item]");
    const ageSelectWrapper = document.querySelector(
      "[data-age-select-wrapper]"
    );
    const childrenAgesDiv = document.querySelector(".children-ages");

    function updateTravellersPeople() {
      const childCount = parseInt(personValueInput.value);

      targetContent.textContent = ", lapsed (" + childCount + ")";

      updateAgeSelectItems();
      updateChildrenAges();
      updateTotalTravellers();
    }

    function updateAgeSelectItems() {
      let currentValue = parseInt(personValueInput.value);

      if (currentValue === 0) {
        ageSelectWrapper.classList.add("hidden");
      } else {
        ageSelectWrapper.classList.remove("hidden");
      }

      ageSelectItems.forEach((item, index) => {
        const ageValueSpan = item.querySelector("[data-age-select-item-value]");
        if (index < currentValue) {
          item.classList.remove("hidden");
          if (ageValueSpan && ageValueSpan.textContent === "") {
            ageValueSpan.textContent = "0";
          }
        } else {
          item.classList.add("hidden");
          // Remove the selected-age class and clear the span if the item is hidden
          const selectedAge = item.querySelector(".selected-age");
          if (selectedAge) {
            selectedAge.classList.remove("selected-age");
          }
          if (ageValueSpan) {
            ageValueSpan.textContent = "";
          }
        }
      });
    }

    function updateChildrenAges() {
      const visibleAgeSelectItems = document.querySelectorAll(
        "[data-age-select-item]:not(.hidden)"
      );
      let childrenAges = [];
      visibleAgeSelectItems.forEach((item) => {
        const selectedAge = item.querySelector(".selected-age");
        if (selectedAge) {
          childrenAges.push(selectedAge.innerHTML + "a");
        }
      });
      childrenAgesDiv.innerHTML = childrenAges.join(", ");
    }

    function addSingleAgeClickListeners() {
      ageSelectItems.forEach((item) => {
        item.addEventListener("click", function (event) {
          if (event.target.hasAttribute("data-single-age")) {
            const singleAgeItems = item.querySelectorAll("[data-single-age]");
            singleAgeItems.forEach((singleAgeItem) => {
              singleAgeItem.classList.remove("selected-age");
            });
            event.target.classList.add("selected-age");
            updateAgeValueInItem(item, event.target.innerHTML);
            updateChildrenAges();
            insertDataToForm();
          }
        });
      });
    }

    function updateAgeValueInItem(item, ageValue) {
      const ageValueSpan = item.querySelector("[data-age-select-item-value]");
      if (ageValueSpan) {
        ageValueSpan.textContent = ageValue;
      }
    }

    minusButton.addEventListener("click", function () {
      let currentValue = parseInt(personValueInput.value);
      if (currentValue > 0) {
        personValueInput.value = currentValue - 1;
      }

      updateTravellersPeople();
      insertDataToForm();
    });

    plusButton.addEventListener("click", function () {
      let currentValue = parseInt(personValueInput.value);
      if (currentValue < 3) {
        personValueInput.value = currentValue + 1;
      }

      updateTravellersPeople();
      insertDataToForm();
    });

    // Initial call to set the visibility and listeners based on the initial value
    updateAgeSelectItems();
    addSingleAgeClickListeners();
  }

  const childrenControlsPresent = document.querySelector(
    ".offerform-child-selector"
  );

  if (childrenControlsPresent) {
    offerFormControlsChildren();
  }

  const peopleSelectorPresent = document.querySelector(
    ".modal-people-select-wrap"
  );

  if (peopleSelectorPresent) {
    updateTotalTravellers();
  }
}
